<template>
    <div>
        <section class="header-image">
            <div class="header-image-overlay"></div>
            <b-container>
                <b-row>
                    <b-col lg="7"><h1>{{ $t('message.fse.title_header') }}</h1>
                        <p class="lead">
                            {{ $t('message.fse.subtitle') }}
                        </p>
                    </b-col>
                    <b-col md="5">
                        <div class="header-breadcrumb">
                            <router-link class="link-alt" :to="{ name: $i18n.locale + '_home' }">{{ $t('message.home.title') }}</router-link>
                            • <span class="text-muted">{{ $t('message.fse.title') }}</span>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>
        <section class="section bg-gray-alt">
            <div class="container text-center">
                <img class="img-fluid" src="../assets/images/FSE-IG256-Profesionais40.png" alt="Progama Profesionais 4.0">
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "Fse",
        metaInfo () {
            return {
                htmlAttrs: {
                    lang: this.$i18n.locale
                },
                title: this.$t('meta.fse.title'),
                link: [
                    { rel: 'canonical', href: 'https://www.syntelix.net' + this.$route.path.replace(/\/$/, "") }
                ],
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: this.$t('meta.fse.description')
                    },
                    {
                        vmid: 'og:title',
                        property: 'og:title',
                        content: this.$t('meta.fse.title')
                    },
                    {
                        vmid: 'og:description',
                        property: 'og:description',
                        content: this.$t('meta.fse.description')
                    },
                    {
                        vmid: 'og:type',
                        property: 'og:type',
                        content: 'website'
                    },
                    {
                        vmid: 'og:image',
                        property: 'og:image',
                        content: 'https://syntelix-website.s3-eu-west-1.amazonaws.com/og.jpg'
                    },
                    {
                        vmid: 'og:url',
                        property: 'og:url',
                        content: 'https://www.syntelix.net' + this.$route.path
                    }
                ]
            }
        }
    }
</script>
